import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_HAULS':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_HAULS':
      return Object.assign({}, state, {
        haulList: action.payload.data,
        loading: action.loading
      })
    case 'ADD_HAUL':
      const newHaulList = [...state.haulList, { ...action.payload.data }].sort((a, b) => {
        return a.haulId.localeCompare(b.haulId, 'en', { sensitivity: 'base' })
      })
      return Object.assign({}, state, {
        haulList: newHaulList
      })
    case 'EDIT_HAUL':
      const updatedHaulIndex = state.haulList.findIndex(
        haul => haul._id === action.payload.data._id
      )
      return Object.assign({}, state, {
        haulList: [
          ...state.haulList.slice(0, updatedHaulIndex),
          { ...action.payload.data },
          ...state.haulList.slice(updatedHaulIndex + 1)
        ],
        loading: action.loading
      })
    default:
      return state
  }
}

export default reducer
